import { deepResearchColor } from "@app/config/constants";
import ElapsedTime from "@lib/common/components/ElapsedTime/ElapsedTime";
import ShimmerText from "@lib/common/components/ShimmerText/ShimmerText";
import { Group, Loader, Stack, Text } from "@mantine/core";

/** The in-flight progress update: loader, shimmering progress line, how far along, and how long it's been running. */
export default function ActiveStatusItem({ label, startedAt }: { label: string; startedAt: Date }) {
  return (
    // miw={0}: flex items won't shrink below their content, pushing the loader out instead of ellipsizing.
    <Stack gap={5} flex={1} miw={0}>
      <Group gap="xs" wrap="nowrap" miw={0}>
        <Loader size="1rem" color={deepResearchColor} style={{ flexShrink: 0 }} />
        {/* Label and timer share one truncating line, so the less important timer is cut first.
            truncate, not lineClamp: -webkit-box plus ShimmerText's background-clip hides text in Chromium. */}
        <Text size="sm" lh={1} truncate miw={0}>
          <ShimmerText span size="sm" fw={500}>
            {label}
          </ShimmerText>
          <ElapsedTime since={startedAt} size="sm" c="dimmed" ml="xs" />
        </Text>
      </Group>
    </Stack>
  );
}
